import type { ReactElement } from "react";

import TypographyPro from "themes/TypographyPro"

import { EditingRow as StyledEditingRow, EditingRowTitle, EditingRowSubTitle, EditingRowAction, EditingRowActionText } from "../style";

const EditingRow = ({title, description, icon = null, action} : {title: string, description: string, icon: ReactElement | null, action: undefined | (() => Promise<void>) | (() => void)}) => (
        <StyledEditingRow>
            <EditingRowTitle>
                <TypographyPro variant="BodyRegularHighlighted">{title}:</TypographyPro> 
                {icon && 
                    <EditingRowSubTitle>
                        {icon}
                        <TypographyPro variant="Subhead">{description}</TypographyPro>
                    </EditingRowSubTitle>
                }
                {!icon && 
                    <TypographyPro variant="Subhead">{description}</TypographyPro>
                }
            </EditingRowTitle>
            
            {action !== undefined &&
                <EditingRowAction>
                    <EditingRowActionText onClick={action} variant="CTATextBig">Change</EditingRowActionText>
                </EditingRowAction>
            }
        </StyledEditingRow>
    )

export default EditingRow
